import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import ProfileSettingsView from './ProfileSettings.view';

import * as fromApp from '../../store/app';
import * as authActions from '../../store/actions/auth';

import { Clients } from 'app/enums/clients'; 
import { LocalStorage } from 'app/constants/StorageConstants';

interface PropsFromState {
  client: Clients | null;
}

interface PropsFromDispatch {
  logout: () => void;
}

interface Props extends PropsFromState, PropsFromDispatch { }

const ProfileSettings: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const options = [
    { value: 0, label: t('profileSettings.options.info') },
    { value: 1, label: t('profileSettings.options.trips') },
    { value: 2, label: t('profileSettings.options.logout') },
  ];

  const onSelectedOption = useCallback((optionIndex) => {
    switch (optionIndex) {
      case 0: // user profile
        break;
      case 1: // my trips
        navigate(`/${props.client}/trips`);
        break;
      case 2: // logout
        localStorage.removeItem(LocalStorage.Token);
        props.logout();
        break;
    }
  }, [props.client]);

  return (
    <ProfileSettingsView options={options} onClickOption={onSelectedOption}>
      {props.children}
    </ProfileSettingsView>
  );
};

ProfileSettings.displayName = 'ProfileSettings';
ProfileSettings.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState) => {
  return {
    client: state.settings.specs?.client || null,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => {
  return {
    logout: (): authActions.Logout => dispatch(authActions.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSettings);
